export default "__VITE_ASSET__BkNQuIFc__"